'use es6';

import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import { SuspensionTooltip } from 'ui-suspension-banners-lib';
import { getIsReadOnly } from 'FileManagerCore/selectors/Permissions';
import ScopedFeatureTooltip from 'FileManagerCore/components/permissions/ScopedFeatureTooltip';
import AddFolderModal from 'FileManagerCore/components/AddFolderModal';
import { addFolder } from '../actions/Folders';
import { FILE_MANAGER_ACCOUNT_VERIFICATION_SOURCE, FILE_MANAGER_WRITE_SCOPE } from 'FileManagerCore/Constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class AddFolderButton extends Component {
  constructor(props) {
    super(props);
    this.handleButtonClick = () => {
      this.setState({
        isOpen: !this.state.isOpen
      });
    };
    this.handleClose = () => {
      this.setState({
        isOpen: false
      });
    };
    this.handleCreate = folderName => {
      const {
        dispatch,
        currentFolder
      } = this.props;
      dispatch(addFolder({
        name: folderName,
        parentId: currentFolder ? currentFolder.get('id') : null
      }));
      this.setState({
        isOpen: false
      });
    };
    this.state = {
      isOpen: false
    };
  }
  addFolderButton() {
    const {
      isReadOnly,
      disabled
    } = this.props;
    return /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "add-folder-button",
      use: "secondary",
      disabled: isReadOnly || disabled,
      onClick: this.handleButtonClick,
      size: "small",
      children: I18n.text('FileManagerDashboard.addFolderButton.createFolder')
    });
  }
  render() {
    const {
      objects,
      isReadOnly,
      disabled,
      disabledTooltip
    } = this.props;
    const {
      isOpen
    } = this.state;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(SuspensionTooltip, {
        scope: FILE_MANAGER_WRITE_SCOPE,
        source: FILE_MANAGER_ACCOUNT_VERIFICATION_SOURCE,
        children: ({
          scopeDisabled
        }) => scopeDisabled ? this.addFolderButton() : /*#__PURE__*/_jsx(ScopedFeatureTooltip, {
          titleOverride: disabledTooltip,
          disableOverride: !(isReadOnly || disabled),
          children: this.addFolderButton()
        })
      }), isOpen && /*#__PURE__*/_jsx(AddFolderModal, {
        objects: objects,
        onClose: this.handleClose,
        onCreate: this.handleCreate
      })]
    });
  }
}
AddFolderButton.propTypes = {
  currentFolder: PropTypes.instanceOf(Immutable.Map),
  dispatch: PropTypes.func,
  objects: PropTypes.instanceOf(Immutable.List),
  isReadOnly: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.node
};
AddFolderButton.defaultProps = {
  disabled: false
};
const mapStateToProps = state => ({
  isReadOnly: getIsReadOnly(state)
});
export default connect(mapStateToProps)(AddFolderButton);